import { Stack } from '@mui/material'
import NoDataBlock from 'components/farm/shared/NoDataBlock'
import { MilkYieldChart } from 'components/milk-yield/components/MilkYeildCard/components/MilkYieldChart/MilkYieldChart'
import MilkYieldInfo from 'components/milk-yield/components/MilkYeildCard/components/MilkYieldInfo/MilkYieldInfo'
import { useGetRangeDate } from 'components/milk-yield/components/MilkYeildCard/hooks/useGetRangeDate'
import { getDaysBetweenDates } from 'components/shared/processes'
import { isDateRangeLongerThanMonths } from 'components/shared/processes/chartDateAggregation'
import { useGetMilkYieldChart } from 'hook/query/useGetMilkYieldChart'

import { CardStandart } from 'ui/CardStandart'
import { DateRestriction } from 'ui/DatePickerInput'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'

import Preloader from 'ui/Preloader'
import { TypographyHeader } from 'ui/typography/TypographyHeader'

interface MilkingYieldBlockProps {
	groupId: string | number
	barnId: number
	cattleCount: number
}

export const MilkingYieldBlock = ({
	groupId,
	barnId,
	cattleCount,
}: MilkingYieldBlockProps) => {
	const { dateRange, onChangeCallback } = useGetRangeDate()
	const { data, isLoading } = useGetMilkYieldChart({
		start: dateRange.startDate,
		end: dateRange.endDate,
		barn_id: barnId,
		...(typeof groupId === 'number' && { group_id: groupId }),
	})
	const daysBetweenDates = getDaysBetweenDates(dateRange)
	const shouldAggregateMonthly = isDateRangeLongerThanMonths(dateRange, 3)
	const isEmptyGraph = data?.graph?.length === 0 || !data?.graph
	return (
		<Stack direction='column' gap='24px'>
			<CardStandart sx={{ padding: '24px' }}>
				<Stack direction='column' gap='24px' minHeight='350px'>
					<TypographyHeader>Надои</TypographyHeader>

					<DateRangePicker
						onChangeUpdateDate={onChangeCallback}
						weekFilter
						monthFilter
						currentRange={'Неделя'}
						startDate={dateRange.startDate}
						endDate={dateRange.endDate}
						restrictionType={DateRestriction.PAST}
					/>
					{isLoading ? (
						<Preloader />
					) : isEmptyGraph ? (
						<NoDataBlock margin={'100px 0'} />
					) : (
						<>
							<MilkYieldInfo
								sellMilk={data?.total_sell_milk_sum}
								rejectedMilk={data?.total_reject_milk_sum}
							/>
							<MilkYieldChart
								graph={data?.graph}
								daysBetweenDates={daysBetweenDates}
								shouldAggregateMonthly={shouldAggregateMonthly}
								cowCount={cattleCount}
							/>
						</>
					)}
				</Stack>
			</CardStandart>
		</Stack>
	)
}
